import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DownloadApi } from 'src/api';
import { downloadFile, ToastV2Service } from '@schenck/rotec-components';

@Injectable()
export class DownloadService {
  private readonly downloadApi = inject(DownloadApi);
  private readonly toastService = inject(ToastV2Service);
  private readonly translate = inject(TranslateService);

  /**
   * Retrieves the PDF-Export for Machine-Tasks which still have to be done (non executed).
   */
  downloadNonExecutedMachineTaskPDF(ids: string[]) {
    const filename = this.getName(
      ids,
      'MC_FILE_NonExecutedMachineTask_Single',
      'MC_FILE_NonExecutedMachineTask_Multiple'
    );
    this.downloadApi.getMachineTaskListPDF$(ids).subscribe(this.handleResponse(filename));
    this.showToast();
  }

  /**
   * Retrieves the PDF-Export for Machine-Tasks which still have been done (executed).
   */
  downloadExecutedMachineTaskPDF(ids: string[]) {
    const filename = this.getName(
      ids,
      'MC_FILE_ExecutedMachineTask_Single',
      'MC_FILE_ExecutedMachineTask_Multiple'
    );
    this.downloadApi.getMachineTaskHistoryPDF$(ids).subscribe(this.handleResponse(filename));
    this.showToast();
  }

  /**
   * Retrieves the PDF-Export for Tooling-Tasks which still have to be done (non executed).
   */
  downloadNonExecutedToolingTaskPDF(ids: string[]) {
    const filename = this.getName(
      ids,
      'MC_FILE_NonExecutedToolingTask_Single',
      'MC_FILE_NonExecutedToolingTask_Multiple'
    );
    this.downloadApi.getToolingTaskListPDF$(ids).subscribe(this.handleResponse(filename));
    this.showToast();
  }

  /**
   * Retrieves the PDF-Export for Tooling-Tasks which still have been done (executed).
   */
  downloadExecutedToolingTaskPDF(ids: string[]) {
    const filename = this.getName(
      ids,
      'MC_FILE_ExecutedToolingTask_Single',
      'MC_FILE_ExecutedToolingTask_Multiple'
    );
    this.downloadApi.getToolingTaskHistoryPDF$(ids).subscribe(this.handleResponse(filename));
    this.showToast();
  }

  private getName(ids: string[], single: string, multiple: string) {
    return ids.length === 1
      ? this.translate.instant(single, { value: ids[0] })
      : this.translate.instant(multiple);
  }

  private handleResponse = (name: string) => {
    return {
      next: (blob: Blob) => downloadFile(blob, name, 'pdf', 'application/pdf'),
      error: () => this.toastService.open({ type: 'error', text: 'Download failed' }),
    };
  };

  private showToast() {
    this.toastService.open({ type: 'success', text: 'Download started' });
  }
}
